import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import LibraryItemStore from '../library-item-store';
import PlaceholderEditing from './placeholder-editing';

export default class Placeholder extends Plugin {
  static get requires() {
    return [PlaceholderEditing];
  }

  init() {
    if (this.PWCIngestionService) {
      this.PWCIngestionService.setLibraryItemStore(LibraryItemStore);
    }
  }
}
